// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GridImages_wrapper__a687I","item":"GridImages_item__0kn3K","image":"GridImages_image__9amel"};